import { coerceChartRowSeriesValues } from '../coerceChartRowSeriesValues';
import { lineOrBarWideRows } from '../lineOrBarWideRows';
import {
  asChartData,
  axisNumberFormat,
  chartPresentationProps,
  seriesToChartConfig,
} from '../presentation';
import type {
  LineOrBarAdapterConfig,
  LineOrBarAdapterProps,
  RenderAdapterResult,
} from '../types';
import { validateRowsInput } from '../validateRowsInput';

function emptyProps(
  config: LineOrBarAdapterConfig | undefined,
): LineOrBarAdapterProps {
  const series = config ? [...config.series] : [];
  return {
    ...config?.presentation?.passthrough,
    data: [],
    series,
    xAxisKey: config?.xAxisKey ?? '',
    yAxisFormat: axisNumberFormat(config?.presentation?.yAxisFormat),
    config: seriesToChartConfig(series, config?.presentation?.series),
    ...chartPresentationProps(config?.presentation),
  };
}

export function lineAdapter(
  rows: unknown,
  config: LineOrBarAdapterConfig,
): RenderAdapterResult<LineOrBarAdapterProps> {
  const validated = validateRowsInput(rows, emptyProps(config));
  if ('props' in validated) {
    return validated;
  }

  const wideResult = lineOrBarWideRows(validated.rows, config);
  if ('error' in wideResult) {
    return { props: emptyProps(config), error: wideResult.error };
  }

  const series = [...config.series];

  return {
    props: {
      ...config.presentation?.passthrough,
      data: asChartData(
        coerceChartRowSeriesValues(wideResult.rows, config.series),
      ),
      series,
      xAxisKey: config.xAxisKey,
      yAxisFormat: axisNumberFormat(config.presentation?.yAxisFormat),
      config: seriesToChartConfig(series, config.presentation?.series),
      ...chartPresentationProps(config.presentation),
    },
  };
}
